import React from 'react';
import Modal from 'react-modal';
import { FaUser, FaUserPlus, FaUserCog, FaTimes } from 'react-icons/fa';
import LoadingSpinner from './LoadingSpinner.jsx';
import { useT } from '../../contexts/LocaleContext.jsx';
import { withStrong } from '../../_helpers/richMessage.jsx';
import '../../styles/partial/PromotionConfirmDialog.css';

const PromotionConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  user,
  promotionType,
  isLoading
}) => {
  const t = useT();

  const getPromotionDetails = () => {
    if (promotionType === 'member') {
      return {
        title: t('followers.promotion.memberTitle'),
        icon: <FaUserPlus />,
        message: t('followers.promotion.memberQuestion', { name: user.display_name }),
        description: t('followers.promotion.memberDescription'),
        confirmText: t('followers.promotion.memberConfirm'),
        confirmClass: 'member-confirm'
      };
    }
    
    if (promotionType === 'moderator') {
      return {
        title: t('followers.promotion.moderatorTitle'),
        icon: <FaUserCog />,
        message: t('followers.promotion.moderatorQuestion', { name: user.display_name }),
        description: t('followers.promotion.moderatorDescription'),
        confirmText: t('followers.promotion.moderatorConfirm'),
        confirmClass: 'moderator-confirm'
      };
    }
    
    return {};
  };

  const details = getPromotionDetails();

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="promotion-confirm-modal"
      overlayClassName="promotion-confirm-overlay"
      ariaHideApp={false}
    >
      <div className="promotion-confirm-content">
        <div className="promotion-confirm-header">
          <div className="promotion-icon">
            {details.icon}
          </div>
          <h3>{details.title}</h3>
          <button 
            className="modal-close-button"
            onClick={onClose}
            disabled={isLoading}
            aria-label={t('common.actions.close')}
          >
            <FaTimes aria-hidden="true" />
          </button>
        </div>

        <div className="promotion-confirm-body">
          <div className="user-info">
            <div className="user-avatar">
              {user.profile_image_url ? (
                <img 
                  src={user.profile_image_url} 
                  alt={user.display_name}
                  className="avatar-image"
                />
              ) : (
                <FaUser className="avatar-placeholder" />
              )}
            </div>
            <div className="user-details">
              <h4>{user.display_name}</h4>
              <span>{t('followers.promotion.username', { username: user.username })}</span>
            </div>
          </div>

          <div className="promotion-message">
            <h4>{details.message}</h4>
            <p>{details.description}</p>
          </div>

          {promotionType === 'member' && (
            <div className="promotion-warning">
              {withStrong(t('followers.promotion.warningText'), { label: t('followers.promotion.warningLabel') })}
            </div>
          )}
        </div>

        <div className="promotion-confirm-actions">
          <button
            onClick={onClose}
            className="confirm-cancel-button"
            disabled={isLoading}
          >
            {t('common.actions.cancel')}
          </button>
          <button
            onClick={onConfirm}
            className={`confirm-button ${details.confirmClass}`}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <LoadingSpinner size="small" />
                <span>{t('followers.promotion.promoting')}</span>
              </>
            ) : (
              <>
                {details.icon}
                <span>{details.confirmText}</span>
              </>
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PromotionConfirmDialog;